import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController,AlertController,Platform } from 'ionic-angular';

import { Http } from '@angular/http';
import { MenuController } from 'ionic-angular';
import { Commontask } from '../../providers/commontask'
import { Webservice } from '../../providers/webservice'
import { Storagehelper } from '../../providers/storagehelper'
import { Events } from 'ionic-angular';
import { SocialSharing } from '@ionic-native/social-sharing';
import { LocalNotifications } from '@ionic-native/local-notifications';
/**
 * Generated class for the DeletereminderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 @IonicPage()
@Component({
  selector: 'page-deletereminder',
  templateUrl: 'deletereminder.html',
})
export class DeletereminderPage extends Commontask{
 public reminders;
 constructor(public navCtrl: NavController, public navParams: NavParams,public menuctrl: MenuController,public http:Http,public webservice:Webservice,public loader:LoadingController,public storage:Storagehelper,public event:Events,public alertCtrl:AlertController,public platform:Platform,public socialShare:SocialSharing,public localnotifcation:LocalNotifications) {
		super(menuctrl,event,platform,socialShare,alertCtrl);
		this.reminders=[];
		this.getAllReminders();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DeletereminderPage');
  }

  getAllReminders(){
    this.storage.getStorageItem('reminders').then((data)=>{
      this.reminders=data;
    })
  }

  deleteReminder(item){
      this.confirmDelete().then((result)=>{
       if(result==true){
           this.storage.deleteItem("reminders","reminder_id",item.reminder_id).then((data)=>{
             this.unscheduleReminder(this.localnotifcation,item.reminder_id);
              this.getAllReminders();
            })
       }
     });
  }




   ionViewDidEnter(){
    // if(this.audioplayer.src!=""){
    //   this.Play();
    // }
    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewCanEnter(){

    this.event.publish('app:changeHeaderBackground'); 
  }

  ionViewWillEnter(){
    this.event.publish('app:changeHeaderBackground'); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/deletereminder/deletereminder.ts